import { deserializeResponse, serializeDTO, TypedRequestExecutor } from '@cloudsuite/cs-ordering-defs'
import { fetcher } from 'components/shared/fetcher.js'

export class OrderingError extends Error {}

async function executeOrderingRequestUntyped(request: any): Promise<any> {
  const url = new URL(`/ordering/${request.constructor.name}/`, window.location.href)
  const response = await fetcher.fetch(
    url,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: serializeDTO(request),
    }
  )

  if (!response.ok) {
    throw new OrderingError()
  }

  return deserializeResponse(await response.json())
}

const executeOrderingRequest: TypedRequestExecutor = executeOrderingRequestUntyped

export { executeOrderingRequest }
